import { render, staticRenderFns } from "./UsuariosView.vue?vue&type=template&id=943c5fe8"
import script from "./UsuariosView.vue?vue&type=script&lang=js"
export * from "./UsuariosView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports